export default "__VITE_ASSET__BS1O7_Ze__"